import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { ColDef } from '@ag-grid-community/core';

@Injectable({
  providedIn: 'root',
})
export class ColumnDefinitionsService {
  #translocoService: TranslocoService = inject(TranslocoService);

  getTranslatedColumnDefinitions(columnDefs: ColDef[], translationScope: string): ColDef[] {
    return columnDefs.map((colDef: ColDef) => ({
      ...colDef,
      headerName: colDef.field?.length
        ? this.#translocoService.translate('tableColumns.' + colDef.field, {}, translationScope)
        : colDef.field,
    }));
  }
}
